module.exports = __webpack_public_path__ + "static/media/cta-bg.c5be1c9c.jpg";